<template>
    <div :class="badgeClasses">
        <slot name="icon"></slot>
        <slot></slot>
    </div>
</template>

<script setup lang="ts">
    import { computed } from 'vue';
    import { BadgeVariant } from '@/types/components/base-components.types';

    // ----- props -----
    const props = withDefaults(
        defineProps<{
            variant?: BadgeVariant;
        }>(),
        {
            variant: () => BadgeVariant.Gray,
        }
    );

    // ----- computed -----
    const badgeClasses = computed(() => {
        return ['badge', `badge-${props.variant}`];
    });
</script>

<style scoped lang="scss">
    @use 'sass:map';

    $badge-config: (
        gray: (
            class: 'gray',
            color: $textColor888,
            bg: #f4f4f4,
        ),
        pink: (
            class: 'pink',
            color: #ffffff,
            bg: #f07d91,
        ),
        purple: (
            class: 'purple',
            color: #ffffff,
            bg: #a55cd1,
        ),
        teal: (
            class: 'teal',
            color: #ffffff,
            bg: #61cdbd,
        ),
        lime: (
            class: 'lime',
            color: #ffffff,
            bg: #9bc225,
        ),
        orange: (
            class: 'orange',
            color: #ffffff,
            bg: #ef9c55,
        ),
        magenta: (
            class: 'magenta',
            color: #ffffff,
            bg: #d643b1,
        ),
    );

    .badge {
        display: inline-flex;
        padding-inline: 8px;
        border-radius: 100px;
        font-size: 0.88rem;
        line-height: 150%;
        align-items: center;
        justify-content: center;
    }

    @each $key, $value in $badge-config {
        $class: map.get($value, class);
        $color: map.get($value, color);
        $bg: map.get($value, bg);

        .badge-#{$class} {
            color: $color;
            background-color: $bg;
        }
    }
</style>
